var map = {
	"./2003_335x235.png": 83,
	"./2004_335x235.png": 84,
	"./2005_335x235.png": 85,
	"./2006_335x235.png": 86,
	"./2007_335x235.png": 87,
	"./2008_335x235.png": 88,
	"./2009_335x235.png": 89,
	"./2010_335x235.png": 90,
	"./2011_335x235.png": 91,
	"./2012_335x235.png": 92,
	"./2013_335x235.png": 93,
	"./2014_335x235.png": 94,
	"./2015_335x235.png": 95,
	"./2016_335x235.png": 96,
	"./2017_335x235.png": 97,
	"./2018_335x235.png": 98,
	"./2019_335x235.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;